/* Doggy card carousels: drag with the mouse like a finger (Boris, 2026-10-20). Touch already scrolls natively. */
(function () {
  if (window.__dgDrag) return; window.__dgDrag = true;
  var SEL = '.dg-pain,.dg-gal,.dg-rev,.dg-jr__row';
  function bind(el) {
    if (el.__dgDrag) return; el.__dgDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || el.scrollWidth <= el.clientWidth + 2) return;
      if (e.target.closest && e.target.closest('a,button')) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
      el.style.scrollSnapType = 'none'; el.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; el.style.cursor = '';
      var left = el.scrollLeft; el.style.scrollSnapType = '';
      el.scrollLeft = left; // let snap settle to the nearest card
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function init() { document.querySelectorAll(SEL).forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
